// extracted by mini-css-extract-plugin
export var leftAlign = "_2k-2";
export var popper = "_2k-0";
export var subtitle = "_2k-1";